import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPNameSectionUI from './PDPNameSectionUI';
import usePdpIsModularBYOProduct from '../state/context/usePdpIsModularBYOProduct';
import PDPNameSectionPlaceholder from './PDPNameSectionPlaceholder';
const PDPNameSectionInner = t0 => {
  const $ = _c(13);
  const {
    isEditOrder: t1
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const {
    loading,
    error,
    data
  } = usePDPBasicDetails();
  if (!data && loading) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <PDPNameSectionUI loading={true} />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  if (error) {
    return "Something went wrong, please try again";
  }
  let t2;
  if ($[1] !== data) {
    t2 = data ?? {};
    $[1] = data;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    name: t3
  } = t2;
  const name = t3 === undefined ? "" : t3;
  let t4;
  if ($[3] !== data?.attributes) {
    t4 = data?.attributes?.filter(_temp)[0]?.value;
    $[3] = data?.attributes;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const subtitle = t4;
  let t5;
  if ($[5] !== name || $[6] !== pdpIsModularBYOProduct) {
    t5 = pdpIsModularBYOProduct ? `Build your own ${name.replace(/ modular$/i, "")}` : name;
    $[5] = name;
    $[6] = pdpIsModularBYOProduct;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const finalName = t5;
  let t6;
  if ($[8] !== finalName || $[9] !== isEditOrder || $[10] !== pdpIsModularBYOProduct || $[11] !== subtitle) {
    t6 = <PDPNameSectionUI name={finalName} subtitle={subtitle} loading={false} isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} />;
    $[8] = finalName;
    $[9] = isEditOrder;
    $[10] = pdpIsModularBYOProduct;
    $[11] = subtitle;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
PDPNameSectionInner.propTypes = {
  isEditOrder: PropTypes.bool
};
const PDPNameSection = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPNameSectionPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPNameSectionInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPNameSection;
function _temp(item) {
  return item.code === "product_subtitle";
}